module.exports = __webpack_public_path__ + "static/media/bb-campsite.0d698f82.png";